import styled from 'styled-components';
import { cssVars } from '../lib/styledTheme';

export const ResizablePanelContainer = styled.div<{
  $direction: 'horizontal' | 'vertical';
  $size: number;
  $isResizing: boolean;
}>`
  position: relative;
  ${props => props.$direction === 'horizontal' 
    ? `width: ${props.$size}px; min-width: ${props.$size}px; max-width: ${props.$size}px;`
    : `height: ${props.$size}px; min-height: ${props.$size}px; max-height: ${props.$size}px;`
  }
  display: flex;
  flex-direction: ${props => props.$direction === 'horizontal' ? 'row' : 'column'};
  user-select: ${props => props.$isResizing ? 'none' : 'auto'};
`;

export const ResizeHandle = styled.div<{
  $direction: 'horizontal' | 'vertical';
  $isResizing: boolean;
  $resizeFromLeft?: boolean;
}>`
  position: absolute;
  ${props => props.$direction === 'horizontal'
    ? props.$resizeFromLeft
      ? `
        left: -4px;
        top: 0;
        bottom: 0;
        width: 8px;
        cursor: col-resize;
      `
      : `
        right: -4px;
        top: 0;
        bottom: 0;
        width: 8px;
        cursor: col-resize;
      `
    : `
      bottom: -4px;
      left: 0;
      right: 0;
      height: 8px;
      cursor: row-resize;
    `
  }
  z-index: 10;
  background-color: transparent;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.primary}40;
  }

  ${props => props.$isResizing && `
    background-color: ${cssVars.primary}60;
  `}
`;

